<label class="h4 text-center custom-font-weight w-100 mt-2 mb-3">{{
  data?.DisplayName || data?.Title
}}</label>
<div *ngIf="!isUserUnAuthorized">
  <div class="header">
    <!-- Legend -->
    <div *ngIf="isEditMode" class="d-flex ">
      <button type="button" class="btn btn-sm" matTooltip="Undo" (click)="performGanttActions('undo')"><i
          class="icon-undo"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Redo" (click)="performGanttActions('redo')"><i
          class="icon-redo"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Move Forward" *ngIf="selectedTasks?.length" (click)="performGanttActions('forward')"><i
          class="icon-arrow-back"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Move Backward" *ngIf="selectedTasks?.length" (click)="performGanttActions('backward')"><i
          class="icon-arrow-forward"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Indent" *ngIf="selectedTasks?.length" (click)="performGanttActions('indent')"><i
          class="icon-indent-increase"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Outdent" *ngIf="selectedTasks?.length" (click)="performGanttActions('outdent')"><i
          class="icon-indent-decrease"></i></button>
    </div>
    <div class="d-flex ml-auto">
      <button *ngIf="!isEditMode && (isAdminOrSuperAdmin() || isAuthorizedParticipant('editRecord', tableId))" type="button" class="btn btn-sm" matTooltip="Enable Report Edit"
        (click)="enableGanttEdit()"><i class="icon-edit-fill"></i></button>
      <button *ngIf="isEditMode" type="button" class="btn btn-sm text-primary" matTooltip="Save Gantt Report"
        (click)="saveGanttEdit()"><i class="icon-check"></i></button>
      <button *ngIf="isEditMode" type="button" class="btn btn-sm text-danger" matTooltip="Cancel Gantt Report"
        (click)="cancelGanttEdit()"><i class="icon-close"></i></button>
      <button type="button" class="btn btn-sm" [ngClass]="showCriticalPath ? 'btn-primary':''" matTooltip="Show/Hide Critical Path" (click)="toggleCriticalPath()"><i
          class="icon-timeline"></i></button>    
      <button type="button" class="btn btn-sm" [ngClass]="groupingEnabled ? 'btn-primary':''" *ngIf="groupingAllowed" matTooltip="Enable/Disable Grouping" (click)="toggleGrouping()"><i
          class="icon-group-list"></i></button>     
      <div ngbDropdown>
        <button ngbDropdownToggle class="btn btn-sm" type="button"
          matTooltip="Baseline Render Mode"
          [ngClass]="baselineRenderMode ? 'btn-primary' : ''">
          <i class="material-icons material-icons-view_timeline"></i>
        </button>
        <div ngbDropdownMenu aria-label="Baseline View Options">
          <button *ngFor="let option of baselineOptions" 
                  type="button" 
                  ngbDropdownItem 
                  [attr.aria-selected]="baselineRenderMode === option.value" 
                  (click)="setBaselineRenderMode(option.value)">
            <i *ngIf="baselineRenderMode === option.value" class="icon-check" aria-hidden="true"></i>
            <span [style.marginLeft.px]="baselineRenderMode !== option.value ? 20 : 0">{{ option.label }}</span>
          </button>
        </div>
      </div>
      <button type="button" class="btn btn-sm" matTooltip="Zoom In" (click)="zoomIn()"><i
          class="icon-zoom-in"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Zoom Out" (click)="zoomOut()"><i
          class="icon-zoom-out"></i></button>
      <button type="button" class="btn btn-sm" matTooltip="Show legend" (click)="openModal(legend)">
        <img src="assets/images/icons/gantt-icons/legend-detail.png" class="img-fluid" alt="default-icon"
          style="height: 20px; width: 20px" />
      </button>
      <!-- Export menu -->
      <div ngbDropdown>
        <button matTooltip="Export as" ngbDropdownToggle class="btn btn-sm" type="button">
          <img src="assets/images/icons/default-app-icons/ic_fluent_arrow_download.png" class="img-fluid" alt="default-icon"
            style="height: 20px; width: 20px" />
        </button>
        <div ngbDropdownMenu>
          <button (click)="exportAs(export.value)" type="button" ngbDropdownItem *ngFor="let export of supportedExports">
            <span>{{ export.title }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #legend>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-left">
          <h4 class="modal-title">Legend</h4>
        </div>
        <div class="modal-header-right">
          <button type="button" class="close" (click)="close()">
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
      <div>
        <div class="modal-body-inner">
          <div class="row">
            <div class="col mx-3">
              <h4>Task</h4>
              <div class="mx-3">
                <ul>
                  <!-- <li><b>Orange:</b> New Task</li> -->
                  <li><b>Red:</b> Critical Path</li>
                  <li><b>Green:</b> Project</li>
                  <!-- <li><b>Blue:</b> Incomplete Task, no Baseline Set</li> -->
                  <li><b>Dark Orange:</b> Progress below 100%</li>
                  <li><b>Grey:</b> Progress 100%</li>
                </ul>
              </div>
            </div>
            <div class="col mx-3">
              <h4>Links</h4>
              <div class="mx-3">
                <ul>
                  <!-- <li><b>Orange:</b> Unsaved link, non-critical links</li> -->
                  <li><b>Black:</b> Normal links</li>
                  <li><b>Red:</b> Critical links</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col mx-3">
              <h4>Milestones</h4>
              <div class="mx-3">
                <ul>
                  <li><b>Orange:</b> Incomplete</li>
                  <li><b>Purple:</b> Time period greater than Today</li>
                  <li><b>Black:</b> Completed</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer-bottom">
          <div class="modal-footer-bottom-row d-flex justify-content-end my-2">
            <app-button
              [style]="'secondary'"
              title="Cancel"
              (onClick)="close()"
              class="mr-2"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<div
  class="gantt-container"
  [ngStyle]="{
    display: isUserUnAuthorized ? 'none' : ''
  }"
  #ganttContainerRef
></div>

<div *ngIf="isUserUnAuthorized" style="position: absolute">
  User is not authorized to see this report
</div>
